import Button, {BtnColor} from "../../../components/Button/Button";
import {useDispatch} from "react-redux";
import {onOrderActionClick, onOrderVisibleRefundReason} from "../../../store/Orders/actions";
import {useState} from "react";
import RefundModal from "./RefundModal";

const ListDetailsActions = ({ order }) => {
    const dispatch = useDispatch();

    const [cancelModalVisible, setCancelModalVisible] = useState(false)
    const [orderAction, setOrderAction] = useState(null)

    const onCancel = () => {
        dispatch(onOrderVisibleRefundReason(false))
        setCancelModalVisible(false)
        setOrderAction(null)
    }

    const actionOrder = (orderId, action) => {
        if (action && action.actionName === 'staff_canceled_action') {
            dispatch(onOrderVisibleRefundReason(true))
            setOrderAction(action)
        } else {
            dispatch(onOrderActionClick(orderId, action))
        }
    }

    const onRefund = (orderId) => {
        dispatch(onOrderActionClick(orderId, orderAction))
    }

    return (
        <>
            <RefundModal order={order}
                         onCancel={onCancel}
                         onRefund={() => onRefund(order.id)} />

            <div className="mr-2" >
                {order.buttons && order.buttons.map(item => (
                    <Button key={item.text}
                            className="ml-2"
                            color={item.color}
                            onClick={() => actionOrder(order.id, item.action)}>{item.text}</Button>
                ) )}
            </div>
        </>

    )
}

export default ListDetailsActions;
